<template>
  <v-autocomplete :value="innerValue" v-bind="attrs" v-on="listeners" :search-input.sync="search" />
</template>

<script>
import { searchAteco } from '@/services/search-api.service'

export default {
  name: 'SearchAtecoField',
  inheritAttrs: false,
  components: {},
  props: {
    value: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    innerValue: null,
    items: [],
    isLoading: false,
    search: null,
  }),
  computed: {
    attrs() {
      return {
        noDataText: 'Nessun risultato',
        ...this.$attrs,
        items: this.items,
        itemValue: 'id',
        itemText: 'desc',
        returnObject: true,
        loading: this.isLoading,
      }
    },
    listeners() {
      return {
        ...this.$listeners,
        input: this.onInput,
      }
    },
  },
  watch: {
    value(newVal) {
      if (!newVal) {
        this.innerValue = null
        this.items = []
      } else {
        this.innerValue = Object.assign({}, newVal)
        this.items = newVal ? [newVal] : []
      }
    },

    search(val) {
      if (!val) return
      if (val.length < 3) return
      if (this.isLoading) return

      this.isLoading = true

      searchAteco(val)
        .then(({ data }) => {
          this.items = data
        })
        .catch((err) => {
          console.error(err)
        })
        .finally(() => (this.isLoading = false))
    },
  },
  created() {
    if (!this.value) {
      this.innerValue = null
      this.items = []
    } else {
      this.innerValue = Object.assign({}, this.value)
      this.items = [this.innerValue]
    }
  },
  methods: {
    onInput(value) {
      this.innerValue = value
      this.$emit('input', value)
    },
  },
}
</script>

<style lang="scss" scoped></style>
